<script setup>
  import { saleOpen, saleClosedMsg } from '@/composables/useEvent';
  import { computed } from 'vue';
  import {
    resolveAvailableTickets,
    shouldShowAvailability,
  } from '@/utils/ticketAvailability';

  const props = defineProps({
    event: {
      type: Object,
      default: () => {},
    },
  });

  const showAvailability = computed(() => {
    return shouldShowAvailability(props.event);
  });

  const availableTickets = computed(() => {
    return resolveAvailableTickets(props.event);
  });

  const shouldRenderAvailability = computed(() => {
    return showAvailability.value && availableTickets.value !== null;
  });
</script>

<template>
  <div v-if="saleOpen(event)">
    <!-- Only show availability if event has limited tickets -->
    <div
      v-if="shouldRenderAvailability"
      class="flex items-center space-x-2 text-sm text-gray-500"
    >
      <i class="fa-duotone fa-ticket fa-lg"></i>

      <span v-if="availableTickets > 0">
        nog
        <b>{{ availableTickets }}</b>
        tickets beschikbaar
      </span>
      <span v-else class="text-xs uppercase">UITVERKOCHT</span>
    </div>
  </div>
  <div v-else class="text-xs text-orange-600">
    {{ saleClosedMsg(event) }}
  </div>
</template>
